module.exports = __webpack_public_path__ + "img/ltkwedding-4x.93c57d2.jpg";